import React from "react"
import styled from "styled-components"
import { AosWrapper } from "../../molecules/AosWrapper"
import { MissionVisionContent } from "../../atoms"

const Wrapper = styled.div`
  width: 100%;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  padding: 80px 120px;
  background: ${(props) => props.theme.bgSectorColor};

  @media (max-width: 1023px) {
    padding: 50px 60px;
  }
  @media (max-width: 600px) {
    padding: 40px 20px;
  }
`
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
  @media (max-width: 1023px) {
    gap: 40px;
  }
  @media (max-width: 600px) {
    gap: 20px;
    flex-direction: column;
  }
`
const Divider = styled.div`
  border-left: 1px solid #1e2538;
  width: 0;
  align-self: stretch;

  @media (max-width: 600px) {
    border-left: none;
    border-top: 1px solid #1e2538;
    width: 100%;
    height: 0;
    align-self: auto;
  }
`

const MissionVision: React.FC = () => {
  return (
    <Wrapper>
      <AosWrapper>
        <Container>
          <MissionVisionContent
            iconSrc={"/assets/icons/mission.svg"}
            title={"OUR MISSION"}
            description={
              "To become a 'Leading Global Company' as a group of\n entrepreneurs"
            }
          />
          <Divider />
          <MissionVisionContent
            iconSrc={"/assets/icons/vision.svg"}
            title={"OUR VISION"}
            description={
              "To become a group of entrepreneurs with 'Be a\n professional' attitude."
            }
          />
        </Container>
      </AosWrapper>
    </Wrapper>
  )
}

export { MissionVision }
